export default __webpack_public_path__ + "static/media/3_Paths_Mobile.b470f047.jpg";